<div class="flex flex-col gap-4">
  <app-src-settings-activation
    *ngIf="(devicesStore.isSelectedDeviceOBNG$ | async) === false"
    [gatewaySerial]="gatewaySerial"
    [deviceSelectId]="(devicesStore.selectedDevice$ | async).id"
  ></app-src-settings-activation>

  <app-src-room-control-mode></app-src-room-control-mode>

  <app-src-settings-algorithms></app-src-settings-algorithms>

  <app-src-settings-connection-status></app-src-settings-connection-status>
</div>
